module.exports = __webpack_public_path__ + "img/8_20.051e0b3e.png";